import { ADMIN_URL } from '../../Admin/constants/constants';

const routes = [{ name: 'Projects', link: `/${ADMIN_URL}/projects/`, isDefault: true }];

export { routes };
